var DbHelper, MASTER_PROJECT_ID, MDA_TABLE_DOC_PREFIX, MDA_TOPIC, MDA_TOPIC_DOC_PREFIX, MdaTableDoc, MdgPublicationApi, PUBLICATION_PLATFORM_PUBLICATION_STATUS_DOC_ID, PublicationStatusDoc, QUESTION_STATUS_PREFIX, QuestionsListComponentActions, REFERENCE_PREFIX, W, alt, callMethod, convertRowsToArray, deriveHandoutIdFromTopicId, errorHandlerWithMsg, errorHandlerWithMsgCurried, fetchIdsForTopics, generateActions, get, getAllDocIdsForHandouts, getNamedGUIDV3, mediator, sequence, _ref, _ref1, _ref2, _ref3,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

alt = require('alt');

_ref = require('lib/app_utils'), convertRowsToArray = _ref.convertRowsToArray, errorHandlerWithMsg = _ref.errorHandlerWithMsg, errorHandlerWithMsgCurried = _ref.errorHandlerWithMsgCurried;

_ref1 = require('base/lib/utils'), callMethod = _ref1.callMethod, getNamedGUIDV3 = _ref1.getNamedGUIDV3;

DbHelper = require('base/lib/db_helper');

generateActions = require('actions/utils/generate_actions');

_ref2 = require('lib/mda_helper'), fetchIdsForTopics = _ref2.fetchIdsForTopics, MASTER_PROJECT_ID = _ref2.MASTER_PROJECT_ID, getAllDocIdsForHandouts = _ref2.getAllDocIdsForHandouts;

MdaTableDoc = require('lib/db_docs/mda_table_doc');

_ref3 = require('lib/doc_prefixes'), MDA_TOPIC_DOC_PREFIX = _ref3.mdaTopic, MDA_TABLE_DOC_PREFIX = _ref3.mdaTable, REFERENCE_PREFIX = _ref3.reference, QUESTION_STATUS_PREFIX = _ref3.questionStatus;

MDA_TOPIC = require('lib/db_docs/doc_types').MDA_TOPIC;

MdgPublicationApi = require('actions/async/mdg_publication_api');

mediator = require('mediator');

get = require('lodash').get;

deriveHandoutIdFromTopicId = require('lib/mda_handouts_helper').deriveHandoutIdFromTopicId;

PUBLICATION_PLATFORM_PUBLICATION_STATUS_DOC_ID = require('lib/doc_ids').PUBLICATION_PLATFORM_PUBLICATION_STATUS;

PublicationStatusDoc = require('lib/db_docs/publication_platform_status_doc');

QuestionsListComponentActions = require('actions/questions_list_component_actions');

sequence = require('when/sequence');

W = require('when/when');

module.exports = generateActions({
  autoGenerate: ['changeStatusFilter', 'closePublicationModal', 'fetchError', 'fetchSuccess', 'publishError', 'publishSuccess', 'setPublicationDialogTopicProgressMaxCount', 'setSearchText', 'toggleConfirmationDialogOpen', 'toggleTopics', 'updateOverallPublicationProgress', 'updateTopicPublicationProgress'],
  name: 'MdaWorkflowPublicationActions',
  actions: {
    dbChange: function(change, _pending, _lastSeq) {
      if (change.id === PUBLICATION_PLATFORM_PUBLICATION_STATUS_DOC_ID) {
        return this.dispatch(change.doc);
      } else {
        return QuestionsListComponentActions.dbChange(change, _pending, _lastSeq);
      }
    },
    fetch: function(_arg) {
      var dbId;
      dbId = _arg.dbId;
      this.dispatch();
      return W.all([
        QuestionsListComponentActions.fetch({
          questionsCollectionType: MDA_TOPIC,
          questionType: MDA_TOPIC
        }), PublicationStatusDoc.at(dbId).fetch()["catch"](function(err) {
          if (err.status !== 404) {
            throw err;
          }
          return {};
        })
      ]).then((function(_this) {
        return function(_arg1) {
          var publicationStatusDoc, _questionsResult;
          _questionsResult = _arg1[0], publicationStatusDoc = _arg1[1];
          return _this.actions.fetchSuccess(publicationStatusDoc);
        };
      })(this))["catch"](this.actions.fetchError);
    },
    pushToMaster: function(projectId, projectName, topics, selectedTopicIds) {
      var date, lp, mpCentralReplica, mpLocalReplica, topicIds;
      this.dispatch();
      mpCentralReplica = DbHelper.centralReplica(MASTER_PROJECT_ID);
      mpLocalReplica = DbHelper.localReplica(MASTER_PROJECT_ID);
      lp = DbHelper.localReplica(projectId);
      topicIds = _.pluck(topics, '_id');
      date = Date.now();
      return mpCentralReplica.replicate.to(mpLocalReplica).then(function() {
        return mediator.services.storePersistenceAdapter.fetchWithKeyPrefix(projectId, REFERENCE_PREFIX);
      }).then(function(_arg) {
        var referenceIds, references, referencesRows;
        referencesRows = _arg.rows;
        references = convertRowsToArray(referencesRows);
        referenceIds = _.pluck(references, '_id');
        return W.all([fetchIdsForTopics(projectId, topics, false), fetchIdsForTopics(MASTER_PROJECT_ID, topics, true), MdaTableDoc.at(projectId).fetchMany(), mediator.services.storePersistenceAdapter.fetchWithKeyPrefix(projectId, QUESTION_STATUS_PREFIX)]).then(function(_arg1) {
          var masterDocumentIds, mdaTableRows, projectDocumentIdsWithoutTables, statusesRows, topicIdsWithHandouts, topicIdsWithHandoutsExcluded, topicWithHandouts, topicWithHandoutsExcluded, _ref4, _ref5, _ref6;
          projectDocumentIdsWithoutTables = _arg1[0], masterDocumentIds = _arg1[1], (_ref4 = _arg1[2], mdaTableRows = _ref4.rows), (_ref5 = _arg1[3], statusesRows = _ref5.rows);
          _ref6 = _.chain(statusesRows).pluck('doc').filter(function(doc) {
            return doc.questionId.indexOf(MDA_TOPIC_DOC_PREFIX) === 0;
          }).partition(function(doc) {
            return get(doc, 'handoutExcluded.status', false) !== true;
          }).value(), topicWithHandouts = _ref6[0], topicWithHandoutsExcluded = _ref6[1];
          topicIdsWithHandouts = _.pluck(topicWithHandouts, 'questionId');
          topicIdsWithHandoutsExcluded = _.pluck(topicWithHandoutsExcluded, 'questionId');
          return mediator.services.storePersistenceAdapter.fetch(projectId, topicIdsWithHandouts).then(function(_arg2) {
            var handoutIdsToBeIncludedInPush, topicsWithHandouts;
            topicsWithHandouts = _arg2.rows;
            handoutIdsToBeIncludedInPush = _.chain(topicsWithHandouts).pluck('doc').pluck('handouts').compact().flatten().uniq().value();
            return getAllDocIdsForHandouts(projectId, handoutIdsToBeIncludedInPush);
          }).then(function(includedHandouts) {
            return [projectDocumentIdsWithoutTables.concat(includedHandouts), masterDocumentIds, mdaTableRows];
          }).then(function(_arg2) {
            var docIdsToDeleteFromMaster, docIdsToFetchLocal, docIdsToFetchMaster, masterDocumentIds, mdaTableRows, projectDocumentIds, projectDocumentIdsWithoutTables;
            projectDocumentIdsWithoutTables = _arg2[0], masterDocumentIds = _arg2[1], mdaTableRows = _arg2[2];
            projectDocumentIds = _.uniq(_.union([], projectDocumentIdsWithoutTables, _.pluck(mdaTableRows, 'id')));
            docIdsToDeleteFromMaster = _.chain(masterDocumentIds).difference(projectDocumentIds).reject(function(docId) {
              return docId.indexOf(MDA_TABLE_DOC_PREFIX) === 0;
            }).value();
            docIdsToFetchMaster = _.union([], referenceIds, projectDocumentIds, docIdsToDeleteFromMaster);
            docIdsToFetchLocal = _.union([], referenceIds, projectDocumentIds);
            return W.all([
              mpLocalReplica.allDocs({
                keys: docIdsToFetchMaster
              }), lp.allDocs({
                include_docs: true,
                keys: docIdsToFetchLocal
              })
            ]).then(function(_arg3) {
              var docsToDeleteFromMaster, docsToSave, lpResult, mpResult, revsFromMasterProject;
              mpResult = _arg3[0], lpResult = _arg3[1];
              revsFromMasterProject = _.chain(mpResult.rows).filter(function(row) {
                var _ref7;
                return ((_ref7 = row.value) != null ? _ref7.rev : void 0) != null;
              }).map(function(row) {
                return [row.id, row.value.rev];
              }).object().value();
              docsToDeleteFromMaster = _.chain(docIdsToDeleteFromMaster).filter(function(docId) {
                return docId in revsFromMasterProject;
              }).map(function(docId) {
                return {
                  _id: docId,
                  _rev: revsFromMasterProject[docId],
                  _deleted: true
                };
              }).value();
              docsToSave = _.chain(convertRowsToArray(lpResult.rows)).map(function(doc) {
                var _ref7, _ref8;
                if (doc._id in revsFromMasterProject) {
                  doc._rev = revsFromMasterProject[doc._id];
                } else {
                  delete doc['_rev'];
                }
                if (_ref7 = doc._id, __indexOf.call(topicIdsWithHandoutsExcluded, _ref7) >= 0) {
                  doc.handouts = [];
                }
                if (_ref8 = doc._id, __indexOf.call(topicIds, _ref8) >= 0) {
                  doc.lastUpdateDate = date;
                  doc.lastUpdateProjectName = projectName;
                }
                return doc;
              }).union(docsToDeleteFromMaster).value();
              return mpLocalReplica.bulkDocs(docsToSave);
            });
          });
        }).then(function() {
          return PublicationStatusDoc.at(projectId).updateAsInstance(callMethod('updateGuidelinePublicationDate', date, topicIds));
        }).then(function() {
          return PublicationStatusDoc.at(MASTER_PROJECT_ID).updateAsInstance(callMethod('setQuestionsAsPending', selectedTopicIds));
        }).then(function() {
          return mpLocalReplica.replicate.to(mpCentralReplica);
        });
      })["catch"](errorHandlerWithMsgCurried($.t('dbep:mda_publication_screen.error_pushing_to_master')))["finally"]((function(_this) {
        return function() {
          return _this.actions.toggleConfirmationDialogOpen();
        };
      })(this));
    },
    publish: function(topicIds) {
      this.dispatch(topicIds.length);
      return sequence(_.map(topicIds, (function(_this) {
        return function(mdaTopicId) {
          return function() {
            return _this.actions.publishTopic(mdaTopicId).then(function() {
              return _this.actions.updateOverallPublicationProgress();
            });
          };
        };
      })(this))).then((function(_this) {
        return function() {
          return _this.actions.publishSuccess();
        };
      })(this));
    },
    publishTopic: function(mdaTopicId) {
      var derivedHandoutId, exportPayload, handoutExportPromise, handoutId, handoutPayload, projectId, publishExportedDocumentSections, topic, topicData, topicExportPromise, topicName, updateTimestamp, _ref4, _ref5, _ref6;
      projectId = mediator.project.id;
      updateTimestamp = new Date().getTime();
      topic = alt.stores.QuestionsStore.getQuestion(mdaTopicId);
      topicData = (_ref4 = topic != null ? typeof topic.toJS === "function" ? topic.toJS() : void 0 : void 0) != null ? _ref4 : {};
      topicName = (_ref5 = topicData.name) != null ? _ref5 : '';
      handoutId = (_ref6 = topicData.handouts) != null ? _ref6[0] : void 0;
      derivedHandoutId = deriveHandoutIdFromTopicId(mdaTopicId);
      this.dispatch(topicName);
      publishExportedDocumentSections = (function(_this) {
        return function(_arg, options) {
          var chapters, guidelineDoc, guidelinePayload, guidelineWithParentTopic, parentTopicGuid, parentTopicId, parentTopicOriginalGuid, sections;
          guidelineDoc = _arg[0], chapters = _arg[1], sections = _arg[2];
          if (options == null) {
            options = {};
          }
          parentTopicId = options.parentTopicId, parentTopicOriginalGuid = options.parentTopicOriginalGuid;
          guidelineWithParentTopic = (parentTopicId != null) && (parentTopicOriginalGuid != null) ? (parentTopicGuid = getNamedGUIDV3(parentTopicOriginalGuid), _.extend({}, guidelineDoc, {
            parentTopicId: parentTopicId,
            parentTopicGuid: parentTopicGuid,
            parentTopicOriginalGuid: parentTopicOriginalGuid
          })) : guidelineDoc;
          guidelinePayload = {
            allChaptersIds: _.pluck(chapters, 'id'),
            allSectionIds: _.pluck(sections, 'id'),
            guideline: guidelineWithParentTopic
          };
          return MdgPublicationApi.publishDoc('guideline', projectId, guidelineWithParentTopic.id, guidelinePayload).then(function() {
            _this.actions.updateTopicPublicationProgress();
            return sequence(_.map(chapters, function(chapter) {
              return function() {
                return MdgPublicationApi.publishDoc('chapter', projectId, chapter.id, chapter).then(function() {
                  return _this.actions.updateTopicPublicationProgress();
                });
              };
            }));
          }).then(function() {
            return sequence(_.map(sections, function(section) {
              return function() {
                return MdgPublicationApi.publishDoc('section', projectId, section.id, section).then(function() {
                  return _this.actions.updateTopicPublicationProgress();
                });
              };
            }));
          });
        };
      })(this);
      exportPayload = {
        mdaTopicId: mdaTopicId,
        projectId: projectId
      };
      topicExportPromise = mediator.services.documentSectionsExportService["export"](exportPayload);
      handoutExportPromise = handoutId != null ? (handoutPayload = {
        handoutId: handoutId,
        projectId: projectId
      }, mediator.services.documentSectionsExportService["export"](handoutPayload)) : W.resolve(null);
      return W.all([topicExportPromise, handoutExportPromise]).then((function(_this) {
        return function(_arg) {
          var handoutChapters, handoutExportData, handoutMaxProgress, handoutSections, parentTopicId, parentTopicOriginalGuid, topicChapters, topicExportData, topicGuideline, topicSections, _handoutGuideline;
          topicExportData = _arg[0], handoutExportData = _arg[1];
          topicGuideline = topicExportData[0], topicChapters = topicExportData[1], topicSections = topicExportData[2];
          parentTopicId = topicGuideline.id;
          parentTopicOriginalGuid = topicGuideline.guid;
          handoutMaxProgress = handoutExportData != null ? ((_handoutGuideline = handoutExportData[0], handoutChapters = handoutExportData[1], handoutSections = handoutExportData[2], handoutExportData), 1 + handoutChapters.length + handoutSections.length) : 1;
          _this.actions.setPublicationDialogTopicProgressMaxCount(1 + topicChapters.length + topicSections.length + handoutMaxProgress);
          return publishExportedDocumentSections(topicExportData).then(function() {
            if (handoutExportData != null) {
              return publishExportedDocumentSections(handoutExportData, {
                parentTopicId: parentTopicId,
                parentTopicOriginalGuid: parentTopicOriginalGuid
              });
            } else {
              return MdgPublicationApi.deleteGuideline(projectId, derivedHandoutId)["catch"](function(err) {
                if (err.status !== 404) {
                  throw err;
                }
              }).then(function() {
                return _this.actions.updateTopicPublicationProgress();
              });
            }
          }).then(function() {
            return PublicationStatusDoc.at(mediator.project.id).updateAsInstance(function(docInstance) {
              return docInstance.updateQuestionPublicationDate(updateTimestamp, mdaTopicId).removeQuestionAsPending(mdaTopicId);
            });
          });
        };
      })(this))["catch"]((function(_this) {
        return function(err) {
          _this.actions.publishError(err);
          return errorHandlerWithMsg(err, $.t('dbep:mda_publication_screen.publish_error', {
            topicName: topicName
          }));
        };
      })(this));
    }
  }
});
